module.exports = __webpack_public_path__ + "media/images/riders/small/JAROSLAV_KULHAVY-2ed0af712fb26d0d59648524c3899017.png";